import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Adjusts the selection area to ensure it does not go beyond the specified bounds.
 * @param selection -
 * @param bounds - in pixels
 */
export const clampSelectionArea = (
  selection: [RelativeAbsolutePosition, RelativeAbsolutePosition],
  bounds: [number, number],
): [RelativeAbsolutePosition, RelativeAbsolutePosition] => {
  const [selectionStart, selectionEnd] = selection;
  const [boundsStart, boundsEnd] = bounds;

  const adjustedStartX = Math.max(
    boundsStart,
    Math.min(selectionStart.relative.x, boundsEnd),
  );

  const adjustedStartDiff = selectionStart.relative.x - adjustedStartX;

  const adjustedStart: RelativeAbsolutePosition = {
    relative: {
      x: adjustedStartX,
      y: selectionStart.relative.y,
    },
    absolute: {
      x: selectionStart.absolute.x - adjustedStartDiff,
      y: selectionStart.absolute.y,
    },
  };

  const adjustedEndX = Math.max(
    boundsStart,
    Math.min(selectionEnd.relative.x, boundsEnd),
  );

  const adjustedEndDiff = selectionEnd.relative.x - adjustedEndX;

  const adjustedEnd: RelativeAbsolutePosition = {
    relative: {
      x: adjustedEndX,
      y: selectionEnd.relative.y,
    },
    absolute: {
      x: selectionEnd.absolute.x - adjustedEndDiff,
      y: selectionEnd.absolute.y,
    },
  };

  return [adjustedStart, adjustedEnd];
};
